<clark-chatbot-launcher
    *ngIf="chatbotState === 'closed' || chatbotState === 'minimized'"
    [isCookieBannerVisible]="isCookieBannerVisible"
    (chatbotOpened)="openChatbot()"></clark-chatbot-launcher>

<clark-chatbot-window
    *ngIf="chatbotState === 'open'"
    (chatbotClosed)="closeChatbot()"
    (chatbotMinimized)="minimizeChatbot()"></clark-chatbot-window>
